"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
import Image from "next/image";
import { motion } from "framer-motion";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function CrmAbout() {
  const $ = _c(42);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      once: true,
      amount: 0.25
    };
    t4 = {
      duration: 0.8,
      ease
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== desktopAnimations) {
    t5 = desktopAnimations ? {
      y: [0, -18, 0]
    } : undefined;
    $[8] = desktopAnimations;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== desktopAnimations) {
    t6 = desktopAnimations ? {
      duration: 5,
      repeat: Infinity,
      repeatType: "loop",
      ease: "easeInOut"
    } : undefined;
    $[10] = desktopAnimations;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Image src="/images/crm/about-service.png" alt="about service image" width={800} height={800} className="h-auto w-full object-contain" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6) {
    t8 = <motion.div animate={t5} transition={t6}>{t7}</motion.div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t0 || $[17] !== t1 || $[18] !== t2 || $[19] !== t8) {
    t9 = <motion.div initial={t0} whileInView={t1} animate={t2} viewport={t3} transition={t4} className="mx-auto w-full max-w-[600px] lg:mx-0">{t8}</motion.div>;
    $[16] = t0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[21] = desktopAnimations;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== desktopAnimations) {
    t11 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[23] = desktopAnimations;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== desktopAnimations) {
    t12 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[25] = desktopAnimations;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      once: true,
      amount: 0.25
    };
    t14 = {
      duration: 0.8,
      delay: 0.1,
      ease
    };
    $[27] = t13;
    $[28] = t14;
  } else {
    t13 = $[27];
    t14 = $[28];
  }
  let t15;
  let t16;
  let t17;
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <h2 className="font-poppins mb-6 text-[28px] font-bold leading-[1.35] text-[#0b1354] md:text-[36px] lg:text-[40px] dark:text-white">Transform Home Services with Our On-Demand App</h2>;
    t16 = <p className="mb-6 font-sans text-[16px] font-normal leading-[30px] text-[#6b7280] md:text-[17px] dark:text-gray-300">Simplify the way customers book and manage home services with our feature-rich Home Services App. Designed for a seamless user experience, our app enables easy service booking, real-time tracking, secure payments, and efficient provider management—all in one platform.</p>;
    t17 = <p className="mb-6 font-sans text-[16px] font-normal leading-[30px] text-[#6b7280] md:text-[17px] dark:text-gray-300">Our On-Demand Home Services App is perfect for businesses offering home cleaning, plumbing, electrical repairs, beauty services, and more. Automate your workflow, enhance customer engagement, and scale your business with a customized digital solution.</p>;
    t18 = <p className="font-poppins mb-6 text-[16px] font-bold text-[#0b1354] md:text-[17px] dark:text-white">Want to Build a Custom Home Services App?</p>;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
  } else {
    t15 = $[29];
    t16 = $[30];
    t17 = $[31];
    t18 = $[32];
  }
  let t19;
  let t20;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <GradientButton href="/contact" variant="peach-pink">Get a Free Consultation <FaChevronRight className="ml-1 text-[12px]" /></GradientButton>;
    t20 = <p className="mt-5 mb-0 font-sans text-[15px] leading-[28px] text-[#0A6AB1] dark:text-blue-400 font-medium">India's Leading Home Services App Development Company</p>;
    $[33] = t19;
    $[34] = t20;
  } else {
    t19 = $[33];
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t12) {
    t21 = <motion.div initial={t10} whileInView={t11} animate={t12} viewport={t13} transition={t14} className="text-center lg:text-left">{t15}{t16}{t17}{t18}{t19}{t20}</motion.div>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t12;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t21 || $[40] !== t9) {
    t22 = <section className="bg-white py-[60px] transition-colors duration-300 md:py-[80px] dark:bg-gray-950"><div className="mx-auto w-full max-w-[1240px] px-[15px]"><div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">{t9}{t21}</div></div></section>;
    $[39] = t21;
    $[40] = t9;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  return t22;
}